import { render } from 'solid-js/web';
import 'solid-devtools';
import { Renderer } from 'framework';

import '../style/index.css';
import { version } from '../../../package.json';

const root = document.querySelector('#eidos');
const params = new URLSearchParams(window.location.search);
const id = params.get('id');

console.log('Eidos version ', version);

render(
  () => <Renderer id={id} onContextMenu={(e) => e.preventDefault()} />,
  root,
);
